import { ComponentProps } from 'react';
import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';

export function makeRequestRetrievalActionProps({
  isLoading,
  errorMessage,
  onCancel,
  onConfirm
}: {
  errorMessage?: string;
  isLoading: boolean;
  onCancel(): void;
  onConfirm(): void;
}): ComponentProps<typeof ConfirmationModal> {
  return {
    isLoading,
    content: modalContent,
    title: 'Retrieve Order?',
    cancelButton: {
      color: 'secondary',
      label: 'No'
    },
    actionButton: {
      color: 'primary',
      label: 'Request Retrieval'
    },
    errorMessage,
    onCancel,
    onConfirm
  };
}

const modalContent = [
  `Retrieving an order will allow you to take it out of the locker and return it to the store. The customer's collection code will no longer work.`,
  `If you've already taken it back, you should mark the order Retrieved instead, if it was delivered in error
  Cancelled, or if opened and given to the customer, Collected.`,
  `Are you sure?`
];
